import { FilterItem } from '@ocean/types/dist/filter'
import { ScheduleBaseDetails, RecordingItem } from 'types/event'

export type UpdateScheduleRecordingsParams = {
  scheduleId: Guid
  allowToDownloadRecordings: boolean
}

export type SaveVirtualEventScheduleAttendanceParams = {
  scheduleId: Guid
  participants: string[]
  comment: string
}

export type RouteParams = {
  scheduleId: Guid
}

export enum EventAttendanceTagFilter {
  All,
  CompletedTasks,
  CSTRecordCreated,
  Attended,
}

export type EventAttendanceFilterItems = {
  hasAttendanceConfirmed?: FilterItem
  hasCstRecord?: FilterItem
  tasksCompleted?: FilterItem
}

export type EventAttendanceTagFilterItemNames = keyof EventAttendanceTagFilterItems

export type EventAttendanceTagFilterItem = {
  name: EventAttendanceTagFilterItemNames
  value: FilterItem['value']
}

export type RecordingsSettings = {
  enableRecordingsDownload: boolean
}

export type EventParticipant = {
  userId: Identifier
  name: string
  surname: string
  rankId: Guid
  email: Email
  tasksCompleted: number
  hasCstRecord?: boolean
  hasAttendanceConfirmed: boolean
  canAttendanceBeConfirmed: boolean
  hasAllTasksCompleted: boolean
}

export enum ScheduleAction {
  Start,
  Join,
  End,
  Prepare,
}

export type EventScheduleDetails = ScheduleBaseDetails & {
  canStartEvent: boolean
  isCstRecordDefined: boolean
  actions: ScheduleAction[]
  attendanceComment?: string
}

export type ScheduleDetails = {
  details: EventScheduleDetails
  recordingsSettings: RecordingsSettings | null
  attendance: EventParticipant[]
  recordingUrls: RecordingItem[]
}

export type EventAttendanceTagFilterItems = {
  filter: FilterItem
}
